export default "__VITE_PUBLIC_ASSET__fa32ee0b__"